/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * This module helps you to create a unit measurement selector.
 *
 * @class UnitSelector
 * @static
 * @namespace L
 * @extends Object
 * @module Widgets
 */
define(['display/map'], function(L) {
    'use strict';
    function onPropertyChange(e) {
        var value = e.target.options[e.target.selectedIndex].value;
        this.unitService.setCurrentUnit(value);
    }

    function addOptions(select, values) {
        var option;
        values.forEach(function(value) {
            option = document.createElement('option');
            option.text = value.getLabel();
            option.value = value.getLabel();
            select.add(option);
        });
    }

    function setCurrentUnit(select) {
        var i;
        var currentUnit = select.unitService.getCurrentUnit();
        var unitVal = currentUnit.getLabel();
        for (i = 0; i < select.options.length; ++i) {
            if (select.options[i].value === unitVal) {
                select.selectedIndex = i;
            }
        }
    }

    return {
        /**
         * Returns a {{#crossLink "HTMLSelectElement"}}{{/crossLink}} filled with the supported measurement units.
         *
         * The element has a function bound to its <i>onchange</i> event, which updates the units configuration
         * of the {{#crossLink "UnitService"}}{{/crossLink}} instance given as argument.
         *
         * @method getHtmlElement
         * @param {UnitService} unitService Unit service instance which will be bound to the generated dropdown.
         *     That means, that if you change value in this select, bound unitService will be updated.
         * @return {HTMLSelectElement}
         */
        getHtmlElement: function(unitService) {
            var select;
            if (!unitService) {
                console.error('Unit service not passed to unitSelector!');
                return undefined;
            }
            select = document.createElement('select');
            select.unitService = unitService;
            select.className = 'tomtom-unit-selector';
            addOptions(select, L.UnitService.getSupportedUnits());
            setCurrentUnit(select);
            select.onchange = onPropertyChange;
            return select;
        }
    };
});



// WEBPACK FOOTER //
// ./widgets/controls/unitSelector.js